import { UPDATE_MILESTONES_DATA } from '../actions/milestones-actions-types';
import constants from '../constants';

const initialState = {
  gamesList: [
    constants.MiniGames.carRace,
    constants.MiniGames.cricketBatterChallenge,
    constants.MiniGames.fruitDynasty
  ]
};

export default function milestones(state = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case UPDATE_MILESTONES_DATA:
      return {
        ...state,
        gamesList: action.payload
      };
    default:
      return state;
  }
}
